export default defineNuxtPlugin((nuxtApp) => {
  const isCypress = useCookie<boolean>('cypress');
  const tokenStore = useTokenStore();
  const userStore = useUserStore();

  StrictFetch.init({
    baseURL: '',
    proxyServerCookies: true,
    onRequest: (context) => {
      context.options.headers.set('X-Locale', nuxtApp.$config.public.locale);
      if (isCypress.value) context.options.headers.set('X-Autotest', isCypress.value.toString());
      if (tokenStore.value) context.options.headers.set('Authorization', `Bearer ${tokenStore.value}`);

      configToBaseUrlMapper(context, nuxtApp.$config);
    },
    onResponseError: (context) => {
      if (import.meta.client && context.response?.status === 401 && !/\/?auth\//.test(context.request.toString()))
        userStore.logout();
    },
    onError: (error) => {
      if (nuxtApp.$config.public.siteEnvironment !== 'prod' || import.meta.server) console.error(error);
      if (import.meta.client) logError(error, 'Ошибка запроса');
    },
  });
});
